export default {
  changePassword: {
    "yourPassword": "Introduce tu contraseña",
    "newPassword": 'Introduce la contraseña nueva',
    'repeatPassword': 'Repite la contraseña nueva',
    "submitButton": "Cambiar contraseña"
  }
}